var $ce325e6dd3f9c37a$exports = {};
$ce325e6dd3f9c37a$exports = {
    "Clear search": `Rensa s\xf6kning`
};


export {$ce325e6dd3f9c37a$exports as default};
//# sourceMappingURL=sv-SE.module.js.map
